import * as SERVICES from 'src/services/holidayServices';
import * as ACTIONS from './holidayActions';
import { ROUTE_PATHS as ROUTES } from 'src/routes';
import { getAccessToken } from 'src/redux/login/loginReducer';
import { showSuccess, showError, showWarning } from 'src/redux/globalData/globalDataActionCreator';
import { push } from 'connected-react-router';

export const tryGetHolidayList = (params) => {

    return async (dispatch, getState) => {
        const state = getState();
        const accessToken = getAccessToken(state);
        if (accessToken) {
            const page = params?.page || 0;
            const pageSize = params?.size || 10;

            let paramsToSend = {
                ...params,
                page,
                pageSize
            };

            dispatch(ACTIONS.getHolidayListRequest());
            const response = await SERVICES.listHoliday(accessToken, paramsToSend);

            if (response?.status == 200) {
                dispatch(ACTIONS.getHolidayListRequestSuccess(response?.data));
                return response?.data;
            }
            else if (response?.status == 204) {
                dispatch(ACTIONS.getHolidayListRequestFailure(response?.response?.data || response));
                showWarning(`No se encontraron feriados.`);
            }
            else {
                dispatch(ACTIONS.getHolidayListRequestFailure(response?.response?.data || response));
                showError(`Error al cargar las feriados. Detalle: ${response?.response?.data?.message || response}`);
            }
        }

    };
};

export const tryAddNewHoliday = (params) => {
    return async (dispatch, getState) => {

        const state = getState();
        const accessToken = getAccessToken(state);

        dispatch(ACTIONS.newHolidayRequest());

        if (accessToken) {

            const response = await SERVICES.createHoliday(accessToken, params);

            if (response?.status == 200) {
                dispatch(ACTIONS.newHolidayRequestSuccess(response?.data));
                showSuccess('Se agrego correctamente el feriado.');
                dispatch(push(ROUTES.HOLIDAY_LIST));
            }
            else {
                dispatch(ACTIONS.newHolidayRequestFailure(response?.data?.error));
                showError(`Error al crear el feriado. Detalles: ${response?.response?.data?.message}`);
            }
            return response;
        }
    };
};

export const tryDeleteHoliday = (id) => {
    return async (dispatch, getState) => {
        const state = getState();
        const accessToken = getAccessToken(state);

        dispatch(ACTIONS.deleteHolidayRequest());

        if (accessToken) {

            const response = await SERVICES.deleteHoliday(accessToken, id);

            if (response?.status == 200) {
                dispatch(ACTIONS.deleteHolidayRequestSuccess(response?.data));
                showSuccess('Feriado eliminada correctamente.');
            }
            else {
                dispatch(ACTIONS.deleteHolidayRequestFailure(response?.error || response));
                showError(`Error al eliminar el feriado. Detalle: ${response?.data?.message || response}`);
            }
            return response;
        }
    };
};

export const tryEditHoliday = params => {
    return async (dispatch, getState) => {
        const state = getState();
        const accessToken = getAccessToken(state);

        dispatch(ACTIONS.editHolidayRequest());

        if (accessToken) {

            const response = await SERVICES.editHoliday(accessToken, params);
            if (response?.status == 200) {
                dispatch(ACTIONS.editHolidayRequestSuccess(response?.data));
                showSuccess('Feriado editado correctamente.');
                dispatch(push(ROUTES.HOLIDAY_LIST));
            }
            else {
                dispatch(ACTIONS.editHolidayRequestFailure(response?.error || response));
                showError(`Error al editar el feriado. Detalle: ${response?.response?.data?.message || response?.error}`);
            }
            return response;
        }

    };

};

export const tryGetHolidayTypes = (params) => {
    return async (dispatch, getState) => {
        const state = getState();
        const accessToken = getAccessToken(state);
        if (accessToken) {
            const page = params?.page || 0;
            const pageSize = params?.size || 1000;

            let paramsToSend = {
                ...params,
                page,
                pageSize
            };

            dispatch(ACTIONS.getHolidayTypeListRequest());
            const response = await SERVICES.getHolidayTypeList(accessToken, paramsToSend);

            if (response?.status == 200) {
                dispatch(ACTIONS.getHolidayTypeListRequestSuccess(response?.data));
                return response?.data;
            }
            else if (response?.status == 204) {
                dispatch(ACTIONS.getHolidayTypeListRequestFailure(response?.response?.data || response));
                showWarning(`No se encontraron tipos de feriado.`);
            }
            else {
                dispatch(ACTIONS.getHolidayTypeListRequestFailure(response?.response?.data || response));
                showError(`Error al cargar las los tipos de feriado. Detalle: ${response?.response?.data?.message || response}`);
            }
        }

    };
}
